import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";

//产品类型管理  GET /productBrand/findPage
export function findList({describe,name,page,size}){
    return http.get('/productBrand/findPage',{describe,name,page,size})
  }

//新增产品类型  POST /productBrand/insertProductBrand
export function insertProductBrand(params){
  return http.postJSON("/productBrand/insertProductBrand",params);
}

//更新产品类型POST /productBrand/updateProductBrand
export function updateProductBrand(params){
  return http.postJSON("/productBrand/updateProductBrand",params);
}

//产品类型删除 POST  /productBrand/delete
export function typeDelete(params){
  return http.postJSON("/productBrand/delete?"+jsonToFormData(params),{});
}

////////////////////////////////////////



//产品型号管理 GET /productModel/findPage
export function ModelfindList({describe,modelName,brandId,page,size}){
  return http.get('/productModel/findPage',{describe,modelName,brandId,page,size})
}

//产品型号新增 POST /productModel/insertProductModel
export function insertProductModel(params){
  return http.postJSON("/productModel/insertProductModel?"+jsonToFormData(params),{});
}

//产品型号更新 POST /productModel/updateProductModel
export function updateProductModel(params){
  return http.postJSON("/productModel/updateProductModel?"+jsonToFormData(params),{});
}
//产品型号删除 POST  /productModel/delete
export function modeDelete(params){
  return http.postJSON("/productModel/delete?"+jsonToFormData(params),{});
}





/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////



//配件等级 mcu 硬件 GET /productEdition/findPage
export function EditionfindPage({describe,name,brandId,modelId,type,page,size,startTime,endTime}){
  return http.get('/productEdition/findPage',{describe,name,brandId,modelId,type,page,size,startTime,endTime})
}

// 配件等级  mcu 硬件 新增POST /productEdition/insertProductEdition
export function insertProductEdition(params){
  return http.postJSON("/productEdition/insertProductEdition",params);
}

// 配件等级  mcu 硬件 更新POST /productEdition/updateProductEdition
export function updateProductEdition(params){
  return http.postJSON("/productEdition/updateProductEdition",params);
}

//POST  /productEdition/delete
export function editionDelete(params){
  return http.postJSON("/productEdition/delete?"+jsonToFormData(params),{});
}



/////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////

//结构版本 POST /product/struct/findPage
export function StructuralFindPage(params){
  return http.postJSON('/product/struct/findPage',params)
}
//添加结构总成
export function StructuralAdd(params){
  return http.postJSON('/product/struct/add',params)
}
//添加子版本
export function StructuralAddSubVer(params){
  return http.postJSON('/product/struct/addSubVer',params)
}
//批量审核
export function StructuralBatchSetState(params){
  return http.postJSON('/product/struct/batchSetState',params)
}
//批量删除
export function StructuralBatchDel(params){
  return http.postJSON('/product/struct/batchDel',params)
}
//批量新增
export function StructuralBatchAdd(params){
  return http.postJSON('/product/struct/batchAdd',params)
}
//编辑子版本
export function StructuralEditSubVer(params){
  return http.postJSON('/product/struct/editSubVer',params)
}
//查询未审核的版本
export function StructuralQueryNotCheckVer(params){
  return http.postJSON('/product/struct/queryNotCheckVer',params)
}


/////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////

//软件版本 GET /productSoftware/findPage
export function SoftwarefindPage({describe,version,brandId,modelId,moduleId,page,size}){
  return http.get('/productSoftware/findPage',{describe,version,brandId,modelId,moduleId,page,size})
}

//新增
//POST /productSoftware/insertProductSoftware
export function insertProductSoftware(params){
  return http.postJSON("/productSoftware/insertProductSoftware",params);
}

//POST /productSoftware/updateProductSoftware
export function updateProductSoftware(params){
  return http.postJSON("/productSoftware/updateProductSoftware",params);
}

//操作日志GET /productSoftware/findLogPage
export function findLogPage({id,page,size}){
  return http.get('/productSoftware/findLogPage',{id,page,size})
}

//删除POST /productSoftware/delete
export function softwareDelete(params){
  return http.postJSON("/productSoftware/delete?"+jsonToFormData(params),{});
}

// 级联 GET /productBrand/getCascade
export function getCascade({brandId,modelId}){
  return http.get('/productBrand/getCascade',{brandId,modelId})
}



// /////////////////////////////////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////




//单个出库POST /repe/repe/out
  export function repeOut(params){
    return http.postJSON("/repe/repe/out",params);
  }

//批量出库  POST /repe/repe/outs
export function importXlxSIM(moduleModel,file,netModel,orderNo,clientId) {
  return http.postFormData("/repe/repe/outs",{file:file,moduleModel:moduleModel,netModel:netModel,orderNo:orderNo,clientId:clientId})
 }

 //导出 GET /repe/repe/exportExcel
export function exportExcel(params) {
    return http.getExcel("/repe/repe/exportExcel",params,"导出")
 }

 //编辑 POST /repe/repe/edit
 export function repeEdit(params){
  return http.postJSON("/repe/repe/edit",params);
}

//操作日志 GET /repe/repe/findRepeLog
export function findRepeLog({code,page,size}){
  return http.get('/repe/repe/findRepeLog',{code,page,size})
}

//删除 POST /repe/repe/delete
export function deletes(params){
  return http.postJSON("/repe/repe/delete?"+jsonToFormData(params),{});
}

//退库 POST /repe/repe/getReturn
export function getReturn(params){
  return http.postJSON("/repe/repe/getReturn?"+jsonToFormData(params),{});
}

//报废 /repe/updateScrap
export function updateScrap(params){
  return http.postJSON("/repe/repe/updateScrap?"+jsonToFormData(params),{});
}

//自研入库 POST /repe/repe/put


//单个入库
export function repePut(params){
  return http.postJSON("/repe/repe/put",params);
}







///获取各页面查询数据
export function  getProductType({page,size}){
     return findList({page,size})
}

//ModelfindList
export function  getProductModle({page,size}){
  return ModelfindList({page,size})
}

//EditionfindPage
export function  getProductHardware({type,page,size}){
  return EditionfindPage({type,page,size})
}


export function  getProductSoftware({page,size}){
  return SoftwarefindPage({page,size})
}

export function  getProductStructure({page,size}){
  return StructuralFindPage({page,size})
}



// WEBPACK FOOTER //
// ./src/services/product.js